import { Link } from "@/i18n/i18n-navigation";
import * as React from "react";

interface ShopLinkProps {
  url: string;
  children?: React.ReactNode;
}
export const ShopLink: React.FC<ShopLinkProps> = ({ url, children }) => {
  return <Link href={url}>{children}</Link>;
};
